import React from "react";
import { Card } from "antd";
import { ChartCardProps } from "./types";

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  icon,
  legend,
  extra,
  children,
  className = "",
  style,
}) => {
  const titleWithIcon = icon ? (
    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {icon}
      {title}
    </span>
  ) : (
    title
  );

  return (
    <Card
      title={titleWithIcon}
      extra={extra}
      className={`chart-card ${className}`}
      style={style}
    >
      {legend && <div className="chart-legend-area">{legend}</div>}
      <div className="chart-content-area">{children}</div>
    </Card>
  );
};
